<template>
    <div class="dgm_wrap padding_side mt105 mb90">
        <div class="register">
            <div class="login_title">
                <span v-html="$t('loginText1')"></span>
                <!--          {{$t('loginText1')}}-->
            </div>
            <div class="login_top_img">
                <img src="@/assets/image/main_logo.png" alt="">
            </div>
            <register-social-component></register-social-component>
        </div>
    </div>
<!--    <div class="register_main_wrap">
        <div class="reg_top">
            {{ $t('loginText1') }}
            <br>{{ $t('loginText2') }}
            <div><img src="@/assets/image/main/logo2.png" alt=""></div>
        </div>
        <register-social-component></register-social-component>
    </div>-->
</template>

<script>
import RegisterSocialComponent from "@/components/auth/RegisterSocialComponent";
import {request, setAuthInHeader} from "@/api/request";
import Vue from 'vue'
import EventBus from "@/utils/event-bus";

export default {
    name: "RegisterSocial",
    mixins: [],
    components: {
        RegisterSocialComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {

    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== 'RegisterAfter') {
            this.$localStorage.clear();
            setAuthInHeader('');
        }
        location.href = to.path;
        // return next();
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
